import React from 'react';
import { useTranslation } from 'react-i18next';

import Line from './Line';
import { ILineItem, OnUpdateLine } from './types';

interface IProps {
  onUpdate: OnUpdateLine;
  lines: ILineItem[];
}

export default function Lines({ onUpdate, lines }: IProps) {
  const { t } = useTranslation();

  if (lines.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <div>
          <span className="text-gray-600">{t('BasketIsEmpty')}</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {lines.map(line => (
          <Line key={line.lineId} onUpdate={onUpdate} {...line} />
        ))}
      </div>
    </div>
  );
}
